import React from 'react';
import './ContactUs.css';

function ContactUs() {
  return (
    <div className="contact-page">
      <div className="contact-content">
        <div className="section-heading">
          <div className="accent-line" aria-hidden="true"></div>
          <h1>Contact Us</h1>
        </div>
        <div className="section-body">
        <div className="contact-details">
          <div className="contact-item">
            <div className="contact-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img">
                <title>Envelope icon for general enquiries email</title>
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="#4f7f8d" strokeWidth="2" strokeLinejoin="round"/>
                <path d="M22 6l-10 7L2 6" stroke="#4f7f8d" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className="contact-text">
              <span className="contact-label">For enquiries :</span> <a href="mailto:info@yk2partners.com" aria-label="Email YK2 Partners for general enquiries">info@yk2partners.com</a>
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img">
                <title>Envelope icon for grievances email</title>
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="#4f7f8d" strokeWidth="2" strokeLinejoin="round"/>
                <path d="M22 6l-10 7L2 6" stroke="#4f7f8d" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className="contact-text">
              <span className="contact-label">For grievances :</span> <a href="mailto:services@yk2partners.com" aria-label="Email YK2 Partners for grievances">services@yk2partners.com</a>
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img">
                <title>Map pin icon for Mumbai office location</title>
                <path d="M12 2c-3.87 0-7 3.13-7 7 0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" stroke="#4f7f8d" strokeWidth="2" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className="contact-text">
              <span className="contact-label">Mumbai :</span> 1007B, 10th Floor, One Lodha Place, Senapati Bapat Marg, Lower Parel, Mumbai 400013.
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img">
                <title>Map pin icon for London office location</title>
                <path d="M12 2c-3.87 0-7 3.13-7 7 0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" stroke="#4f7f8d" strokeWidth="2" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className="contact-text">
              <span className="contact-label">London :</span> 42, Bedford Gardens, London, W8 7EH
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
